import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=408f665b&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
import style0 from "./Default.vue?vue&type=style&index=0&id=408f665b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408f665b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408f665b')) {
      api.createRecord('408f665b', component.options)
    } else {
      api.reload('408f665b', component.options)
    }
    module.hot.accept("./Default.vue?vue&type=template&id=408f665b&scoped=true", function () {
      api.rerender('408f665b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Tenants/ChannelIcons/Default.vue"
export default component.exports